import {SimplePage} from "../../elements/Pages";
import React, {useEffect, useState} from "react";
import ListViewTable from "../../elements/tables/ListViewTable";
import {DownloadButton} from "../../elements/Buttons";
import {useSchoolYears} from "../../../contexts/SchoolYearContext";
import SchoolYearFilter from "../../elements/SchoolYearFilter";
import {
    getMissingHomeworkOrMaterialsByStudentReport,
    getMissingHomeworkOrMaterialsByStudentReportExcel
} from "../../../api/reports";
import {useQuery} from "@tanstack/react-query";


const columns = [
    {
        accessorFn: (row) => `${row.last_name}, ${row.first_name} ${row.student_number}`,
        id: "student_search",
        header: "SchülerIn",
        hide: false,
        enableColumnFilter: false,
    },
    {
        accessorKey: "school_class",
        id: "school_class",
        header: "Klasse",
        sortingFn: "schoolClassSorting",
        enableColumnFilter: false
    },
    {
        accessorKey: "house",
        id: "house",
        header: "Mentorat",
        enableColumnFilter: false
    },
    {
        accessorKey: "missing_homework",
        id: "missing_homework",
        columnType: "number",
        header: "HA (ges.)",
        enableColumnFilter: false,
        classNames: "bg-yellow-200",
    },
    {
        accessorKey: "missing_homework_e1",
        id: "missing_homework_e1",
        columnType: "number",
        header: "HA (E1)",
        enableColumnFilter: false,
        classNames: "bg-yellow-50 ",
    },
    {
        accessorKey: "missing_homework_e2",
        id: "missing_homework_e2",
        columnType: "number",
        header: "HA (E2)",
        enableColumnFilter: false,
        classNames: "bg-yellow-50 ",
    },
    {
        accessorKey: "missing_homework_e3",
        id: "missing_homework_e3",
        columnType: "number",
        header: "HA (E3)",
        enableColumnFilter: false,
        classNames: "bg-yellow-50 ",
    },
    {
        accessorKey: "missing_homework_e4",
        id: "missing_homework_e4",
        columnType: "number",
        header: "HA (E4)",
        enableColumnFilter: false,
        classNames: "bg-yellow-50 ",
    },
    {
        accessorKey: "missing_materials",
        id: "missing_materials",
        columnType: "number",
        header: "Mat. (ges.)",
        enableColumnFilter: false,
        classNames: "bg-blue-200 bg-gray-200",
    },
    {
        accessorKey: "missing_materials_e1",
        id: "missing_materials_e1",
        columnType: "number",
        header: "Mat. (E1)",
        enableColumnFilter: false,
        classNames: "bg-blue-50",
    },
    {
        accessorKey: "missing_materials_e2",
        id: "missing_materials_e2",
        columnType: "number",
        header: "Mat. (E2)",
        enableColumnFilter: false,
        classNames: "bg-blue-50",
    },
    {
        accessorKey: "missing_materials_e3",
        id: "missing_materials_e3",
        columnType: "number",
        header: "Mat. (E3)",
        enableColumnFilter: false,
        classNames: "bg-blue-50",
    },
    {
        accessorKey: "missing_materials_e4",
        id: "missing_materials_e4",
        columnType: "number",
        header: "Mat. (E4)",
        enableColumnFilter: false,
        classNames: "bg-blue-50",
    }
]

export default function MissingHomeworkAndMaterialsByStudentReport() {

    const {schoolYears, currentSchoolYear} = useSchoolYears();
    const [schoolYearId, setSchoolYearId] = useState();
    const [timePeriodId, setTimePeriodId] = useState();

    const {isLoading, isError, isSuccess, data, error, refetch} = useQuery(
        ["missing_homework_or_materials_by_student", schoolYearId],
        () => getMissingHomeworkOrMaterialsByStudentReport(schoolYearId),
        {
            enabled: !!schoolYearId, refetchInterval: 1000 * 60 * 60
        }
    )

    useEffect(() => {
        if (currentSchoolYear) setSchoolYearId(currentSchoolYear["id"]);
    }, [currentSchoolYear])

    return (
        <SimplePage>
            <div className="px-4 sm:px-6 lg:px-8">
                <div className="sm:flex sm:items-center">
                    <div className="sm:flex-auto">
                        <h3 className="text-lg leading-6 font-medium text-gray-900">
                            Fehlende Hausaufgaben/Materialien nach Schülern
                        </h3>
                    </div>
                    <div className="mt-4 sm:mt-0 sm:ml-16 sm:flex-none">
                        <DownloadButton
                            apiFunction={() => getMissingHomeworkOrMaterialsByStudentReportExcel(schoolYearId)}
                            fileName="Fehl. HA/Mat nach Schülern.xls"
                            label="Excel herunterladen"/>

                    </div>
                </div>
                <div className="flex flex-col">
                    <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">

                        <div className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
                            <SchoolYearFilter
                                schoolYears={schoolYears}
                                schoolYearId={schoolYearId}
                                setSchoolYearId={setSchoolYearId}
                            />
                        </div>

                        <div className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
                            {data && (
                                <ListViewTable
                                    data={data}
                                    columns={columns}
                                    isLoading={false}
                                    disableGlobalSearch={false}
                                    getRowLink={null}
                                />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </SimplePage>
    );
}
